import { OnboardingFulfilledBy } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../../../../../../shared/components/Text';

export const AllowedOnboardingFulfilledByOptions = Object.values(OnboardingFulfilledBy).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
